import { create } from 'zustand';
import useCVStoreRepository from './cvStoreRepository';
import useCVStoreEmployee from './cvStoreEmployee';

// Set up the notification mechanism - this will be called when the store is first accessed
let notificationsSetup = false;

const setupNotifications = () => {
  if (notificationsSetup) return;
  
  const empStore = useCVStoreEmployee.getState();
  const repoStore = useCVStoreRepository.getState();
  
  // Override the notifyCVSaved function to update both stores
  // MyCV component is accessed from both routes:
  // - /cv-repository/{id} (uses repository store)
  // - /cv-repository/my-cvs/{id} (uses employee store)
  empStore.notifyCVSaved = (savedCV) => {
    // Extract the actual CV data from the API response
    const cvData = savedCV.data || savedCV;
    
    // Update employee store's employeeCVs list (for My CVs route)
    const empResult = empStore.updateCV(cvData);
    
    // Update repository store (for main CV repository route)
    // Always try to update - the updateCV method handles both existing and new CVs
    const repoResult = repoStore.updateCV(cvData);
  };

  // Override the notifyCVDeleted function to update both stores
  empStore.notifyCVDeleted = (cvId) => {
    // Remove from repository store
    const repoResult = repoStore.removeCV(cvId);
  };
  
  notificationsSetup = true;
};

const useCVStore = create(() => {
  // Set up notifications when the store is first accessed
  setupNotifications();
  
  return {
    // This store is now mainly used for setting up the notification system
    // The actual CV updates are handled automatically through the notification mechanism
    setupNotifications, // Expose this for manual setup if needed
  };
});

export default useCVStore; 